<template>
  <div style="position: relative">

    <client-attention-home
        v-if="currentEvent === null && !loadingEvent"
        @change:events="events = $event" />

    <component
        v-else
        :is="attentionComponent"
        @change:events="events = $event"/>


  </div>
</template>

<script>

    import {attentionComponentByService} from '@/utils/Specialist'
    import {mapMutations, mapState} from 'vuex'

    import MedicalTechnologyAttention from '@/components/appointments/attention/specialties_panels/MedicalTechnologyAttention'
    import GeneralMedicineAttention from '@/components/appointments/attention/specialties_panels/GeneralMedicineAttention'
    import PsychologicalAttention from '@/components/appointments/attention/specialties_panels/PsychologicalAttention'
    import SimpleAttention from '@/components/appointments/attention/specialties_panels/SimpleAttention'
    import OphthalmologicalAttention from '@/components/appointments/attention/specialties_panels/OphthalmologicalAttention'
    import AttentionToolSet from '@/components/appointments/attention/toolset/AttentionToolSet'
    import ClientAttentionHome from "@/components/appointments/attention/home_screen/ClientAttentionHome";

    export default{
        components: {
          ClientAttentionHome,
          AttentionToolSet,
          MedicalTechnologyAttention,
          GeneralMedicineAttention,
          PsychologicalAttention,
          OphthalmologicalAttention,
          SimpleAttention
        },
        props:{
            event: {
                type: Object
            }
        },
        data(){
            return {
              events: [],
              loadEventDetailsCallback: () => {}
            }
        },
        mounted(){
            const vm = this
            if(vm.event){
                vm.setEvent(vm.event)
            }
        },
        beforeDestroy(){},
        methods: {
            ...mapMutations('clientAttention', [
                'setEvent'
            ])
        },
        computed:{
          ...mapState('clientAttention', {
            currentEvent: state => state.currentEvent,
            loadingEvent: state => state.loading
          }),
          attentionComponent(){
            const vm = this
            if(!vm.currentEvent || !vm.currentEvent.schedule || !vm.currentEvent.schedule.service_item) return null
            return attentionComponentByService(vm.currentEvent.schedule.service_item.description)
          }
        }
    }
</script>
